module.exports = __webpack_public_path__ + "static/media/check1.d2d6bdb7.svg";